export default {
	active: "Actif",
	content: "Contenu",
	controls: {
		clearDisplay: "Effacer l'affichage",
		playVideo: "Lire la vidéo",
		sendMessage: "Envoyer le message",
		title: "Contrôle de l'affichage",
	},
	deviceAuth: {
		authorize: "Autoriser l'appareil",
		enterCode: "Saisissez le code affiché sur la TV",
		error: "Erreur lors de l'autorisation de l'appareil",
		selectTemple: "Sélectionner le temple",
		subtitle: "Connectez une TV ou un appareil au temple",
		success: "Appareil autorisé avec succès !",
		successDesc: "La TV peut désormais afficher les tickets de votre temple.",
		title: "Autoriser l'appareil",
	},
	editMessage: "Modifier le message",
	inactive: "Inactif",
	messageTitle: "Titre",
	messages: {
		cleared: "Affichage effacé",
		confirmDelete: "Êtes-vous sûr de vouloir supprimer ce message ?",
		created: "Message créé avec succès",
		deleted: "Message supprimé avec succès",
		sent: "Message envoyé à l'affichage",
		updated: "Message mis à jour avec succès",
		videoSent: "Vidéo envoyée à l'affichage",
	},
	newMessage: "Nouveau message",
	oriTv: {
		compatibility: "Compatible avec Fire TV Stick, Android TV et tablettes Android",
		description:
			"Installez l'application ORI TV sur votre Fire TV Stick ou Android TV pour afficher les appels de tickets, les messages et les vidéos sur l'écran du temple.",
		download: "Télécharger ORI TV (.apk)",
		step1: "Téléchargez et installez l'APK sur l'appareil (Fire TV Stick, Android TV ou tablette)",
		step2: "Ouvrez l'application et rendez-vous à l'adresse affichée à l'écran pour autoriser",
		step3: "C'est fait ! Les tickets et les messages apparaîtront automatiquement sur la TV",
		title: "Application ORI TV",
		version: "Version",
	},
	showInQueue: "Afficher dans la file d'attente (pied de page TV)",
	sortOrder: "Ordre",
	subtitle: "Gérez les messages et vidéos affichés sur la TV du temple",
	title: "Affichage / TV",
	totalMessages: "Total",
	type: "Type",
	types: {
		TEXT: "Texte",
		VIDEO: "Vidéo",
	},
	videoUrl: "URL de la vidéo (YouTube)",
};
